import { FiatCurrency } from "../currency";

export type UserSettings = {
  language: string;
  currency: FiatCurrency;
  balanceBelow: number;
  extensionUrl: string;
};
